import { createFileRoute } from '@tanstack/react-router';
import { useLingui } from '@lingui/react/macro';
import { PageSeo } from './-components/page-seo';
import { audiencePageSlugs, parseAudience, type Audience } from './-components/contact/audiences';

/** The audience page itself: everything the questionnaire needs is the shell's, so this is its head. */
export const Route = createFileRoute('/www/contact/$audience/')({
	component: Component,
});

/** Title and description per audience. Written out rather than composed, so each reads as its own page. */
function useSeo(audience: Audience) {
	const { t } = useLingui();
	const copy: Record<Audience, { title: string; description: string }> = {
		company: {
			title: t`Contact for companies - Worldcoo`,
			description: t`Tell us about your business and we'll find the fundraising channel that fits it: rounding up in store, online donation, payroll or invoice rounding.`,
		},
		ngo: {
			title: t`Contact for social entities - Worldcoo`,
			description: t`Are you a social entity? Start the sign-up process to fund your projects through our partner companies' fundraising channels, or write to us with your question.`,
		},
		donor: {
			title: t`Contact for donors - Worldcoo`,
			description: t`Questions about a donation, a refund or your tax certificate? Check the status of your donation yourself, or write to us about your case.`,
		},
		press: {
			title: t`Press and communication - Worldcoo`,
			description: t`Press enquiries, interviews and materials about Worldcoo. Tell us what you need and our communication team will get back to you.`,
		},
	};
	return copy[audience];
}

function Component() {
	const { audience } = Route.useParams();
	const parsed = parseAudience(audience);
	const seo = useSeo(parsed ?? 'company');
	if (!parsed) return null;

	return <PageSeo slugs={audiencePageSlugs(parsed)} title={seo.title} description={seo.description} />;
}
